import * as types from '../constants'
import { Record, Map } from 'immutable'

const cachedPropertyRecord = Record({
  data: Map(),
})

const initialState = new cachedPropertyRecord()

export default (state = initialState, action) => {
  switch (action.type) {
    case types.ADD_MAP_MARKERS_TO_CACHE: {
      const newState = state.mergeDeep({
        data: Map(action.data),
      })
      return newState
    }
    case types.RESET_CACHED_MAP_MARKERS:
      return new cachedPropertyRecord()
    case types.FLAG_PROPERTY: {
      return state.merge({
        data: state.get('data').delete(action.id),
      })
    }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/cachedPropertyMarkers.js